import { BORROWER_OPTIONS, LOAN_TYPE_OPTIONS } from "@/data/educationLoan";
import { LoanField } from "./LoanPrimitives";

export const LoanProfileFields = ({ profile, setProfile, prefix, disabled = false }) => (
  <>
    <LoanField id={`${prefix}-level`} label="Study level">
      <select id={`${prefix}-level`} value={profile.study_level} onChange={(e) => setProfile("study_level", e.target.value)} disabled={disabled} data-testid={`${prefix}-level`} className="loan-control">
        <option value="bachelors">Bachelor’s</option><option value="postgraduate">Postgraduate</option>
      </select>
    </LoanField>
    <LoanField id={`${prefix}-borrower`} label="Co-borrower income type">
      <select id={`${prefix}-borrower`} value={profile.co_borrower} onChange={(e) => setProfile("co_borrower", e.target.value)} disabled={disabled} data-testid={`${prefix}-borrower`} className="loan-control">
        {BORROWER_OPTIONS.map(([value, label]) => <option key={value} value={value} disabled={value === "farmer" && profile.study_level !== "postgraduate"}>{label}</option>)}
      </select>
    </LoanField>
    <LoanField id={`${prefix}-type`} label="Loan preference">
      <select id={`${prefix}-type`} value={profile.loan_type} onChange={(e) => setProfile("loan_type", e.target.value)} disabled={disabled} data-testid={`${prefix}-type`} className="loan-control">
        {LOAN_TYPE_OPTIONS.map(([value, label]) => <option key={value} value={value}>{label}</option>)}
      </select>
    </LoanField>
  </>
);